import * as stylex from '@stylexjs/stylex'
export const color = stylex.defineConsts({
  bg: 'var(--color-bg)',
  bgAssistive: 'var(--color-bg-assistive)',
  bgAssistiveHover: 'var(--color-bg-assistive-hover)',
  bgAssistivePressed: 'var(--color-bg-assistive-pressed)',
  bgAssistiveSecondary: 'var(--color-bg-assistive-secondary)',
  bgAssistiveTertiary: 'var(--color-bg-assistive-tertiary)',
  bgBrand: 'var(--color-bg-brand)',
  bgBrandHover: 'var(--color-bg-brand-hover)',
  bgBrandPressed: 'var(--color-bg-brand-pressed)',
  bgBrandSecondary: 'var(--color-bg-brand-secondary)',
  bgBrandTertiary: 'var(--color-bg-brand-tertiary)',
  bgBrandTertiaryHover: 'var(--color-bg-brand-tertiary-hover)',
  bgBrandTertiaryPressed: 'var(--color-bg-brand-tertiary-pressed)',
  bgComponent: 'var(--color-bg-component)',
  bgComponentHover: 'var(--color-bg-component-hover)',
  bgComponentPressed: 'var(--color-bg-component-pressed)',
  bgComponentSecondary: 'var(--color-bg-component-secondary)',
  bgComponentTertiary: 'var(--color-bg-component-tertiary)',
  bgComponentTertiaryHover: 'var(--color-bg-component-tertiary-hover)',
  bgComponentTertiaryPressed: 'var(--color-bg-component-tertiary-pressed)',
  bgDanger: 'var(--color-bg-danger)',
  bgDangerHover: 'var(--color-bg-danger-hover)',
  bgDangerPressed: 'var(--color-bg-danger-pressed)',
  bgDangerSecondary: 'var(--color-bg-danger-secondary)',
  bgDangerTertiary: 'var(--color-bg-danger-tertiary)',
  bgDangerTertiaryHover: 'var(--color-bg-danger-tertiary-hover)',
  bgDangerTertiaryPressed: 'var(--color-bg-danger-tertiary-pressed)',
  bgDesign: 'var(--color-bg-design)',
  bgDesignHover: 'var(--color-bg-design-hover)',
  bgDesignPressed: 'var(--color-bg-design-pressed)',
  bgDesignSecondary: 'var(--color-bg-design-secondary)',
  bgDesignTertiary: 'var(--color-bg-design-tertiary)',
  bgDesktopBackgrounded: 'var(--color-bg-desktopBackgrounded)',
  bgDesktopBackgroundedDisabled: 'var(--color-bg-desktopBackgrounded-disabled)',
  bgDesktopBackgroundedHover: 'var(--color-bg-desktopBackgrounded-hover)',
  bgDesktopBackgroundedPressed: 'var(--color-bg-desktopBackgrounded-pressed)',
  bgDesktopBackgroundedSecondary: 'var(--color-bg-desktopBackgrounded-secondary)',
  bgDesktopBackgroundedTertiary: 'var(--color-bg-desktopBackgrounded-tertiary)',
  bgDesktopForeground: 'var(--color-bg-desktopForeground)',
  bgDesktopForegroundDisabled: 'var(--color-bg-desktopForeground-disabled)',
  bgDesktopForegroundHover: 'var(--color-bg-desktopForeground-hover)',
  bgDesktopForegroundPressed: 'var(--color-bg-desktopForeground-pressed)',
  bgDesktopForegroundSecondary: 'var(--color-bg-desktopForeground-secondary)',
  bgDesktopForegroundTertiary: 'var(--color-bg-desktopForeground-tertiary)',
  bgDesktopFullscreen: 'var(--color-bg-desktopFullscreen)',
  bgDesktopFullscreenDisabled: 'var(--color-bg-desktopFullscreen-disabled)',
  bgDesktopFullscreenHover: 'var(--color-bg-desktopFullscreen-hover)',
  bgDesktopFullscreenPressed: 'var(--color-bg-desktopFullscreen-pressed)',
  bgDesktopFullscreenSecondary: 'var(--color-bg-desktopFullscreen-secondary)',
  bgDesktopFullscreenTertiary: 'var(--color-bg-desktopFullscreen-tertiary)',
  bgDisabled: 'var(--color-bg-disabled)',
  bgDisabledSecondary: 'var(--color-bg-disabled-secondary)',
  bgElevated: 'var(--color-bg-elevated)',
  bgElevatedHover: 'var(--color-bg-elevated-hover)',
  bgFigjam: 'var(--color-bg-figjam)',
  bgFigjamHover: 'var(--color-bg-figjam-hover)',
  bgFigjamPressed: 'var(--color-bg-figjam-pressed)',
  bgFigjamSecondary: 'var(--color-bg-figjam-secondary)',
  bgFigjamTertiary: 'var(--color-bg-figjam-tertiary)',
  bgFs: 'var(--color-bg-fs)',
  bgFsAssistive: 'var(--color-bg-fs-assistive)',
  bgFsAssistiveSecondary: 'var(--color-bg-fs-assistive-secondary)',
  bgFsAssistiveTertiary: 'var(--color-bg-fs-assistive-tertiary)',
  bgFsComponent: 'var(--color-bg-fs-component)',
  bgFsComponentSecondary: 'var(--color-bg-fs-component-secondary)',
  bgFsComponentTertiary: 'var(--color-bg-fs-component-tertiary)',
  bgFsDesign: 'var(--color-bg-fs-design)',
  bgFsDesignSecondary: 'var(--color-bg-fs-design-secondary)',
  bgFsDesignTertiary: 'var(--color-bg-fs-design-tertiary)',
  bgFsMeasure: 'var(--color-bg-fs-measure)',
  bgFsMeasureHover: 'var(--color-bg-fs-measure-hover)',
  bgFsMeasureSecondary: 'var(--color-bg-fs-measure-secondary)',
  bgFsMeasureTertiary: 'var(--color-bg-fs-measure-tertiary)',
  bgFsSelected: 'var(--color-bg-fs-selected)',
  bgFsSelectedSecondary: 'var(--color-bg-fs-selected-secondary)',
  bgFsTemplate: 'var(--color-bg-fs-template)',
  bgFsTemplateSecondary: 'var(--color-bg-fs-template-secondary)',
  bgFsTemplateTertiary: 'var(--color-bg-fs-template-tertiary)',
  bgFsTertiary: 'var(--color-bg-fs-tertiary)',
  bgHandoff: 'var(--color-bg-handoff)',
  bgHandoffHover: 'var(--color-bg-handoff-hover)',
  bgHandoffPressed: 'var(--color-bg-handoff-pressed)',
  bgHandoffSecondary: 'var(--color-bg-handoff-secondary)',
  bgHandoffTertiary: 'var(--color-bg-handoff-tertiary)',
  bgHover: 'var(--color-bg-hover)',
  bgInfo: 'var(--color-bg-info)',
  bgInverse: 'var(--color-bg-inverse)',
  bgInverseHover: 'var(--color-bg-inverse-hover)',
  bgInversePressed: 'var(--color-bg-inverse-pressed)',
  bgMeasure: 'var(--color-bg-measure)',
  bgMeasureHover: 'var(--color-bg-measure-hover)',
  bgMeasurePressed: 'var(--color-bg-measure-pressed)',
  bgMeasureSecondary: 'var(--color-bg-measure-secondary)',
  bgMeasureTertiary: 'var(--color-bg-measure-tertiary)',
  bgMenu: 'var(--color-bg-menu)',
  bgMenuDisabled: 'var(--color-bg-menu-disabled)',
  bgMenuHover: 'var(--color-bg-menu-hover)',
  bgMenuPressed: 'var(--color-bg-menu-pressed)',
  bgMenuSecondary: 'var(--color-bg-menu-secondary)',
  bgMenuSelected: 'var(--color-bg-menu-selected)',
  bgMenuSelectedHover: 'var(--color-bg-menu-selected-hover)',
  bgMenuSelectedPressed: 'var(--color-bg-menu-selected-pressed)',
  bgMenuSelectedSecondary: 'var(--color-bg-menu-selected-secondary)',
  bgMenuSelectedTertiary: 'var(--color-bg-menu-selected-tertiary)',
  bgMenuTertiary: 'var(--color-bg-menu-tertiary)',
  bgOnselected: 'var(--color-bg-onselected)',
  bgOnselectedHover: 'var(--color-bg-onselected-hover)',
  bgOnselectedPressed: 'var(--color-bg-onselected-pressed)',
  bgPressed: 'var(--color-bg-pressed)',
  bgSecondary: 'var(--color-bg-secondary)',
  bgSecondaryHover: 'var(--color-bg-secondary-hover)',
  bgSecondaryPressed: 'var(--color-bg-secondary-pressed)',
  bgSelected: 'var(--color-bg-selected)',
  bgSelectedHover: 'var(--color-bg-selected-hover)',
  bgSelectedPressed: 'var(--color-bg-selected-pressed)',
  bgSelectedSecondary: 'var(--color-bg-selected-secondary)',
  bgSelectedStrong: 'var(--color-bg-selected-strong)',
  bgSelectedTertiary: 'var(--color-bg-selected-tertiary)',
  bgStrongHover: 'var(--color-bg-strong-hover)',
  bgStrongPressed: 'var(--color-bg-strong-pressed)',
  bgSuccess: 'var(--color-bg-success)',
  bgSuccessHover: 'var(--color-bg-success-hover)',
  bgSuccessPressed: 'var(--color-bg-success-pressed)',
  bgSuccessSecondary: 'var(--color-bg-success-secondary)',
  bgSuccessTertiary: 'var(--color-bg-success-tertiary)',
  bgSuccessTertiaryHover: 'var(--color-bg-success-tertiary-hover)',
  bgSuccessTertiaryPressed: 'var(--color-bg-success-tertiary-pressed)',
  bgTemplate: 'var(--color-bg-template)',
  bgTemplateSecondary: 'var(--color-bg-template-secondary)',
  bgTemplateTertiary: 'var(--color-bg-template-tertiary)',
  bgTertiary: 'var(--color-bg-tertiary)',
  bgToolbar: 'var(--color-bg-toolbar)',
  bgToolbarDisabled: 'var(--color-bg-toolbar-disabled)',
  bgToolbarHover: 'var(--color-bg-toolbar-hover)',
  bgToolbarPressed: 'var(--color-bg-toolbar-pressed)',
  bgToolbarSecondary: 'var(--color-bg-toolbar-secondary)',
  bgToolbarSelected: 'var(--color-bg-toolbar-selected)',
  bgToolbarSelectedHover: 'var(--color-bg-toolbar-selected-hover)',
  bgToolbarSelectedPressed: 'var(--color-bg-toolbar-selected-pressed)',
  bgToolbarSelectedSecondary: 'var(--color-bg-toolbar-selected-secondary)',
  bgToolbarSelectedTertiary: 'var(--color-bg-toolbar-selected-tertiary)',
  bgToolbarTertiary: 'var(--color-bg-toolbar-tertiary)',
  bgTooltip: 'var(--color-bg-tooltip)',
  bgTooltipDisabled: 'var(--color-bg-tooltip-disabled)',
  bgTooltipHover: 'var(--color-bg-tooltip-hover)',
  bgTooltipPressed: 'var(--color-bg-tooltip-pressed)',
  bgTooltipSecondary: 'var(--color-bg-tooltip-secondary)',
  bgTooltipSelected: 'var(--color-bg-tooltip-selected)',
  bgTooltipSelectedHover: 'var(--color-bg-tooltip-selected-hover)',
  bgTooltipSelectedPressed: 'var(--color-bg-tooltip-selected-pressed)',
  bgTooltipSelectedSecondary: 'var(--color-bg-tooltip-selected-secondary)',
  bgTooltipSelectedTertiary: 'var(--color-bg-tooltip-selected-tertiary)',
  bgTooltipTertiary: 'var(--color-bg-tooltip-tertiary)',
  bgTransparent: 'var(--color-bg-transparent)',
  bgTransparentHover: 'var(--color-bg-transparent-hover)',
  bgTransparentPressed: 'var(--color-bg-transparent-pressed)',
  bgTransparentSecondary: 'var(--color-bg-transparent-secondary)',
  bgWarning: 'var(--color-bg-warning)',
  bgWarningHover: 'var(--color-bg-warning-hover)',
  bgWarningPressed: 'var(--color-bg-warning-pressed)',
  bgWarningSecondary: 'var(--color-bg-warning-secondary)',
  bgWarningTertiary: 'var(--color-bg-warning-tertiary)',
  bgWarningTertiaryHover: 'var(--color-bg-warning-tertiary-hover)',
  bgWarningTertiaryPressed: 'var(--color-bg-warning-tertiary-pressed)',
  bgannotationblue: 'var(--color-bgannotationblue)',
  bgannotationgreen: 'var(--color-bgannotationgreen)',
  bgannotationorange: 'var(--color-bgannotationorange)',
  bgannotationpink: 'var(--color-bgannotationpink)',
  bgannotationpurple: 'var(--color-bgannotationpurple)',
  bgannotationred: 'var(--color-bgannotationred)',
  bgannotationteal: 'var(--color-bgannotationteal)',
  bgannotationyellow: 'var(--color-bgannotationyellow)',
  bghoverondarkcanvas: 'var(--color-bghoverondarkcanvas)',
  bghoveronlightcanvas: 'var(--color-bghoveronlightcanvas)',
  bghovertransparent: 'var(--color-bghovertransparent)',
  bginspectpadding: 'var(--color-bginspectpadding)',
  bginspectpaddingtertiary: 'var(--color-bginspectpaddingtertiary)',
  bginspectspacing: 'var(--color-bginspectspacing)',
  bgsecondaryoncanvas: 'var(--color-bgsecondaryoncanvas)',
  bgselectedarea: 'var(--color-bgselectedarea)',
  bgswitchoff: 'var(--color-bgswitchoff)',
  bgtoolbarmodeswitcher: 'var(--color-bgtoolbarmodeswitcher)',
  bgtoolbarmodeswitcherHover: 'var(--color-bgtoolbarmodeswitcher-hover)',
  bgtransparent: 'var(--color-bgtransparent)',
  bgtransparentSecondaryHover: 'var(--color-bgtransparent-secondary-hover)',
  bgtransparentSecondaryPressed: 'var(--color-bgtransparent-secondary-pressed)',
  bgtransparentsecondary: 'var(--color-bgtransparentsecondary)',
  bgvoting: 'var(--color-bgvoting)',
  bgvotingsecondary: 'var(--color-bgvotingsecondary)',
  bgvotingtertiary: 'var(--color-bgvotingtertiary)',
  bgvotingwheeldial: 'var(--color-bgvotingwheeldial)',
  bgvotingwheelhover: 'var(--color-bgvotingwheelhover)',
  border: 'var(--color-border)',
  borderAssistive: 'var(--color-border-assistive)',
  borderAssistiveStrong: 'var(--color-border-assistive-strong)',
  borderBrand: 'var(--color-border-brand)',
  borderBrandStrong: 'var(--color-border-brand-strong)',
  borderComponent: 'var(--color-border-component)',
  borderComponentHover: 'var(--color-border-component-hover)',
  borderComponentSelected: 'var(--color-border-component-selected)',
  borderComponentStrong: 'var(--color-border-component-strong)',
  borderDanger: 'var(--color-border-danger)',
  borderDangerStrong: 'var(--color-border-danger-strong)',
  borderDesign: 'var(--color-border-design)',
  borderDesignStrong: 'var(--color-border-design-strong)',
  borderDesktopBackgrounded: 'var(--color-border-desktopBackgrounded)',
  borderDesktopBackgroundedDisabled: 'var(--color-border-desktopBackgrounded-disabled)',
  borderDesktopBackgroundedStrong: 'var(--color-border-desktopBackgrounded-strong)',
  borderDesktopForeground: 'var(--color-border-desktopForeground)',
  borderDesktopForegroundDisabled: 'var(--color-border-desktopForeground-disabled)',
  borderDesktopForegroundStrong: 'var(--color-border-desktopForeground-strong)',
  borderDesktopFullscreen: 'var(--color-border-desktopFullscreen)',
  borderDesktopFullscreenDisabled: 'var(--color-border-desktopFullscreen-disabled)',
  borderDesktopFullscreenStrong: 'var(--color-border-desktopFullscreen-strong)',
  borderDisabled: 'var(--color-border-disabled)',
  borderDisabledStrong: 'var(--color-border-disabled-strong)',
  borderFigjam: 'var(--color-border-figjam)',
  borderFigjamStrong: 'var(--color-border-figjam-strong)',
  borderFs: 'var(--color-border-fs)',
  borderFsAssistive: 'var(--color-border-fs-assistive)',
  borderFsAssistiveStrong: 'var(--color-border-fs-assistive-strong)',
  borderFsComponent: 'var(--color-border-fs-component)',
  borderFsComponentStrong: 'var(--color-border-fs-component-strong)',
  borderFsDesign: 'var(--color-border-fs-design)',
  borderFsDesignStrong: 'var(--color-border-fs-design-strong)',
  borderFsMeasure: 'var(--color-border-fs-measure)',
  borderFsMeasureStrong: 'var(--color-border-fs-measure-strong)',
  borderFsOnassistive: 'var(--color-border-fs-onassistive)',
  borderFsOnassistiveStrong: 'var(--color-border-fs-onassistive-strong)',
  borderFsOncomponent: 'var(--color-border-fs-oncomponent)',
  borderFsOncomponentStrong: 'var(--color-border-fs-oncomponent-strong)',
  borderFsOndesign: 'var(--color-border-fs-ondesign)',
  borderFsOndesignStrong: 'var(--color-border-fs-ondesign-strong)',
  borderFsOnmeasure: 'var(--color-border-fs-onmeasure)',
  borderFsOnmeasureStrong: 'var(--color-border-fs-onmeasure-strong)',
  borderFsOnselected: 'var(--color-border-fs-onselected)',
  borderFsOnselectedStrong: 'var(--color-border-fs-onselected-strong)',
  borderFsOntemplate: 'var(--color-border-fs-ontemplate)',
  borderFsOntemplateStrong: 'var(--color-border-fs-ontemplate-strong)',
  borderFsSelected: 'var(--color-border-fs-selected)',
  borderFsSelectedStrong: 'var(--color-border-fs-selected-strong)',
  borderFsStrong: 'var(--color-border-fs-strong)',
  borderFsTemplate: 'var(--color-border-fs-template)',
  borderFsTemplateStrong: 'var(--color-border-fs-template-strong)',
  borderHandoff: 'var(--color-border-handoff)',
  borderHandoffStrong: 'var(--color-border-handoff-strong)',
  borderMeasure: 'var(--color-border-measure)',
  borderMeasureStrong: 'var(--color-border-measure-strong)',
  borderMenu: 'var(--color-border-menu)',
  borderMenuDisabled: 'var(--color-border-menu-disabled)',
  borderMenuDisabledStrong: 'var(--color-border-menu-disabled-strong)',
  borderMenuOnselected: 'var(--color-border-menu-onselected)',
  borderMenuOnselectedStrong: 'var(--color-border-menu-onselected-strong)',
  borderMenuSelected: 'var(--color-border-menu-selected)',
  borderMenuSelectedStrong: 'var(--color-border-menu-selected-strong)',
  borderMenuStrong: 'var(--color-border-menu-strong)',
  borderOnassistive: 'var(--color-border-onassistive)',
  borderOnassistiveStrong: 'var(--color-border-onassistive-strong)',
  borderOnbrand: 'var(--color-border-onbrand)',
  borderOnbrandStrong: 'var(--color-border-onbrand-strong)',
  borderOncomponent: 'var(--color-border-oncomponent)',
  borderOncomponentStrong: 'var(--color-border-oncomponent-strong)',
  borderOndanger: 'var(--color-border-ondanger)',
  borderOndangerStrong: 'var(--color-border-ondanger-strong)',
  borderOndesign: 'var(--color-border-ondesign)',
  borderOndesignStrong: 'var(--color-border-ondesign-strong)',
  borderOnfigjam: 'var(--color-border-onfigjam)',
  borderOnfigjamStrong: 'var(--color-border-onfigjam-strong)',
  borderOnmeasure: 'var(--color-border-onmeasure)',
  borderOnmeasureStrong: 'var(--color-border-onmeasure-strong)',
  borderOnselected: 'var(--color-border-onselected)',
  borderOnselectedStrong: 'var(--color-border-onselected-strong)',
  borderOnsuccess: 'var(--color-border-onsuccess)',
  borderOnsuccessStrong: 'var(--color-border-onsuccess-strong)',
  borderOntemplate: 'var(--color-border-ontemplate)',
  borderOntemplateStrong: 'var(--color-border-ontemplate-strong)',
  borderOnwarning: 'var(--color-border-onwarning)',
  borderOnwarningStrong: 'var(--color-border-onwarning-strong)',
  borderSelected: 'var(--color-border-selected)',
  borderSelectedStrong: 'var(--color-border-selected-strong)',
  borderStrong: 'var(--color-border-strong)',
  borderSuccess: 'var(--color-border-success)',
  borderSuccessStrong: 'var(--color-border-success-strong)',
  borderTemplateStrong: 'var(--color-border-template-strong)',
  borderToolbar: 'var(--color-border-toolbar)',
  borderToolbarDisabled: 'var(--color-border-toolbar-disabled)',
  borderToolbarOnselected: 'var(--color-border-toolbar-onselected)',
  borderToolbarSelected: 'var(--color-border-toolbar-selected)',
  borderToolbarSelectedStrong: 'var(--color-border-toolbar-selected-strong)',
  borderToolbarStrong: 'var(--color-border-toolbar-strong)',
  borderTooltip: 'var(--color-border-tooltip)',
  borderTooltipDisabled: 'var(--color-border-tooltip-disabled)',
  borderTooltipDisabledStrong: 'var(--color-border-tooltip-disabled-strong)',
  borderTooltipOnselected: 'var(--color-border-tooltip-onselected)',
  borderTooltipOnselectedStrong: 'var(--color-border-tooltip-onselected-strong)',
  borderTooltipSelected: 'var(--color-border-tooltip-selected)',
  borderTooltipSelectedStrong: 'var(--color-border-tooltip-selected-strong)',
  borderTooltipStrong: 'var(--color-border-tooltip-strong)',
  borderWarning: 'var(--color-border-warning)',
  borderWarningStrong: 'var(--color-border-warning-strong)',
  borderinspectpadding: 'var(--color-borderinspectpadding)',
  borderinspectspacing: 'var(--color-borderinspectspacing)',
  borderplacecrosshair: 'var(--color-borderplacecrosshair)',
  borderselectedec: 'var(--color-borderselectedec)',
  bordertranslucent: 'var(--color-bordertranslucent)',
  bordertranslucentstrong: 'var(--color-bordertranslucentstrong)',
  code: 'var(--color-code)',
  codeaccent: 'var(--color-codeaccent)',
  codeattribute: 'var(--color-codeattribute)',
  codeclassname: 'var(--color-codeclassname)',
  codecomment: 'var(--color-codecomment)',
  codeproperty: 'var(--color-codeproperty)',
  codestring: 'var(--color-codestring)',
  codestylename: 'var(--color-codestylename)',
  codetag: 'var(--color-codetag)',
  codevalue: 'var(--color-codevalue)',
  codevariable: 'var(--color-codevariable)',
  conditionalborder: 'var(--color-conditionalborder)',
  controliconoutline: 'var(--color-controliconoutline)',
  controlknoboffoutline: 'var(--color-controlknoboffoutline)',
  fillplacecrosshair: 'var(--color-fillplacecrosshair)',
  fsAutoFillHighlight: 'var(--color-fsAutoFillHighlight)',
  fsBgHeaderOnDarkCanvas: 'var(--color-fsBgHeaderOnDarkCanvas)',
  fsBgHeaderOnLightCanvas: 'var(--color-fsBgHeaderOnLightCanvas)',
  fsBgInputOnLightCanvas: 'var(--color-fsBgInputOnLightCanvas)',
  fsBorderDesignShadowStrong: 'var(--color-fsBorderDesignShadowStrong)',
  fsBorderHeaderOnDarkCanvas: 'var(--color-fsBorderHeaderOnDarkCanvas)',
  fsBorderHeaderOnLightCanvas: 'var(--color-fsBorderHeaderOnLightCanvas)',
  fsBorderPlaceholder: 'var(--color-fsBorderPlaceholder)',
  fsBorderSelectedImmutableNode: 'var(--color-fsBorderSelectedImmutableNode)',
  fsBorderSelectedImmutableNodeSecondary: 'var(--color-fsBorderSelectedImmutableNodeSecondary)',
  fsCanvasDefaultFill: 'var(--color-fsCanvasDefaultFill)',
  fsCodeNodeBorder: 'var(--color-fsCodeNodeBorder)',
  fsCodeNodeBorderSecondary: 'var(--color-fsCodeNodeBorderSecondary)',
  fsCodeNodeTextErrorOnDarkCanvas: 'var(--color-fsCodeNodeTextErrorOnDarkCanvas)',
  fsCodeNodeTextErrorOnLightCanvas: 'var(--color-fsCodeNodeTextErrorOnLightCanvas)',
  fsCodeNodeTextOnDarkCanvas: 'var(--color-fsCodeNodeTextOnDarkCanvas)',
  fsCodeNodeTextOnLightCanvas: 'var(--color-fsCodeNodeTextOnLightCanvas)',
  fsDevHandoffAutolayoutPadding: 'var(--color-fsDevHandoffAutolayoutPadding)',
  fsDevHandoffAutolayoutSpacing: 'var(--color-fsDevHandoffAutolayoutSpacing)',
  fsFrameDefaultFill: 'var(--color-fsFrameDefaultFill)',
  fsGridCellOutline: 'var(--color-fsGridCellOutline)',
  fsGridCellSelection: 'var(--color-fsGridCellSelection)',
  fsGridComponentCellOutline: 'var(--color-fsGridComponentCellOutline)',
  fsGridComponentCellSelection: 'var(--color-fsGridComponentCellSelection)',
  fsIconOnDarkCanvas: 'var(--color-fsIconOnDarkCanvas)',
  fsIconOnDarkCanvasSecondary: 'var(--color-fsIconOnDarkCanvasSecondary)',
  fsIconOnLightCanvas: 'var(--color-fsIconOnLightCanvas)',
  fsIconOnLightCanvasSecondary: 'var(--color-fsIconOnLightCanvasSecondary)',
  fsNodeHandle: 'var(--color-fsNodeHandle)',
  fsNodeLabelNoBG: 'var(--color-fsNodeLabelNoBG)',
  fsNodeSymbolSelectedSecondary: 'var(--color-fsNodeSymbolSelectedSecondary)',
  fsNoodleCenterLine: 'var(--color-fsNoodleCenterLine)',
  fsShapeDefaultFill: 'var(--color-fsShapeDefaultFill)',
  fsSitesResponsiveSetTextOnDarkCanvas: 'var(--color-fsSitesResponsiveSetTextOnDarkCanvas)',
  fsSitesResponsiveSetTextOnLightCanvas: 'var(--color-fsSitesResponsiveSetTextOnLightCanvas)',
  fsSnappingOverlay: 'var(--color-fsSnappingOverlay)',
  fsStickyAuthorTextOnDark: 'var(--color-fsStickyAuthorTextOnDark)',
  fsStickyAuthorTextOnLight: 'var(--color-fsStickyAuthorTextOnLight)',
  fsTextComponentOnDarkCanvas: 'var(--color-fsTextComponentOnDarkCanvas)',
  fsTextComponentOnLightCanvas: 'var(--color-fsTextComponentOnLightCanvas)',
  fsTextOnDarkCanvas: 'var(--color-fsTextOnDarkCanvas)',
  fsTextOnDarkCanvasSecondary: 'var(--color-fsTextOnDarkCanvasSecondary)',
  fsTextOnLightCanvas: 'var(--color-fsTextOnLightCanvas)',
  fsTextOnLightCanvasSecondary: 'var(--color-fsTextOnLightCanvasSecondary)',
  fsTextSelectedOnDarkCanvas: 'var(--color-fsTextSelectedOnDarkCanvas)',
  fsTextSelectedOnLightCanvas: 'var(--color-fsTextSelectedOnLightCanvas)',
  fsVectorInactive: 'var(--color-fsVectorInactive)',
  fsWidgetFrameTextOnDarkCanvas: 'var(--color-fsWidgetFrameTextOnDarkCanvas)',
  fsWidgetFrameTextOnLightCanvas: 'var(--color-fsWidgetFrameTextOnLightCanvas)',
  fsWidgetFrameTextSelectedOnDarkCanvas: 'var(--color-fsWidgetFrameTextSelectedOnDarkCanvas)',
  fsWidgetFrameTextSelectedOnLightCanvas: 'var(--color-fsWidgetFrameTextSelectedOnLightCanvas)',
  gauge: 'var(--color-gauge)',
  gaugeBrand: 'var(--color-gauge-brand)',
  gaugeBrandSecondary: 'var(--color-gauge-brand-secondary)',
  gaugeDanger: 'var(--color-gauge-danger)',
  gaugeDangerSecondary: 'var(--color-gauge-danger-secondary)',
  gaugeSecondary: 'var(--color-gauge-secondary)',
  gaugeStrong: 'var(--color-gauge-strong)',
  gaugeSuccess: 'var(--color-gauge-success)',
  gaugeSuccessSecondary: 'var(--color-gauge-success-secondary)',
  gaugeWarning: 'var(--color-gauge-warning)',
  gaugeWarningSecondary: 'var(--color-gauge-warning-secondary)',
  icon: 'var(--color-icon)',
  iconAssistive: 'var(--color-icon-assistive)',
  iconAssistivePressed: 'var(--color-icon-assistive-pressed)',
  iconAssistiveSecondary: 'var(--color-icon-assistive-secondary)',
  iconAssistiveTertiary: 'var(--color-icon-assistive-tertiary)',
  iconBrand: 'var(--color-icon-brand)',
  iconBrandPressed: 'var(--color-icon-brand-pressed)',
  iconBrandSecondary: 'var(--color-icon-brand-secondary)',
  iconBrandTertiary: 'var(--color-icon-brand-tertiary)',
  iconComponent: 'var(--color-icon-component)',
  iconComponentPressed: 'var(--color-icon-component-pressed)',
  iconComponentSecondary: 'var(--color-icon-component-secondary)',
  iconComponentTertiary: 'var(--color-icon-component-tertiary)',
  iconDanger: 'var(--color-icon-danger)',
  iconDangerHover: 'var(--color-icon-danger-hover)',
  iconDangerPressed: 'var(--color-icon-danger-pressed)',
  iconDangerSecondary: 'var(--color-icon-danger-secondary)',
  iconDangerSecondaryHover: 'var(--color-icon-danger-secondary-hover)',
  iconDangerTertiary: 'var(--color-icon-danger-tertiary)',
  iconDesign: 'var(--color-icon-design)',
  iconDesignPressed: 'var(--color-icon-design-pressed)',
  iconDesignSecondary: 'var(--color-icon-design-secondary)',
  iconDesignTertiary: 'var(--color-icon-design-tertiary)',
  iconDesktopBackgrounded: 'var(--color-icon-desktopBackgrounded)',
  iconDesktopBackgroundedDanger: 'var(--color-icon-desktopBackgrounded-danger)',
  iconDesktopBackgroundedDisabled: 'var(--color-icon-desktopBackgrounded-disabled)',
  iconDesktopBackgroundedHover: 'var(--color-icon-desktopBackgrounded-hover)',
  iconDesktopBackgroundedOndisabled: 'var(--color-icon-desktopBackgrounded-ondisabled)',
  iconDesktopBackgroundedSecondary: 'var(--color-icon-desktopBackgrounded-secondary)',
  iconDesktopBackgroundedSecondaryHover: 'var(--color-icon-desktopBackgrounded-secondary-hover)',
  iconDesktopBackgroundedTertiary: 'var(--color-icon-desktopBackgrounded-tertiary)',
  iconDesktopBackgroundedTertiaryHover: 'var(--color-icon-desktopBackgrounded-tertiary-hover)',
  iconDesktopBackgroundedWarning: 'var(--color-icon-desktopBackgrounded-warning)',
  iconDesktopForeground: 'var(--color-icon-desktopForeground)',
  iconDesktopForegroundDanger: 'var(--color-icon-desktopForeground-danger)',
  iconDesktopForegroundDisabled: 'var(--color-icon-desktopForeground-disabled)',
  iconDesktopForegroundHover: 'var(--color-icon-desktopForeground-hover)',
  iconDesktopForegroundOndisabled: 'var(--color-icon-desktopForeground-ondisabled)',
  iconDesktopForegroundSecondary: 'var(--color-icon-desktopForeground-secondary)',
  iconDesktopForegroundSecondaryHover: 'var(--color-icon-desktopForeground-secondary-hover)',
  iconDesktopForegroundTertiary: 'var(--color-icon-desktopForeground-tertiary)',
  iconDesktopForegroundTertiaryHover: 'var(--color-icon-desktopForeground-tertiary-hover)',
  iconDesktopForegroundWarning: 'var(--color-icon-desktopForeground-warning)',
  iconDesktopFullscreen: 'var(--color-icon-desktopFullscreen)',
  iconDesktopFullscreenDanger: 'var(--color-icon-desktopFullscreen-danger)',
  iconDesktopFullscreenDisabled: 'var(--color-icon-desktopFullscreen-disabled)',
  iconDesktopFullscreenHover: 'var(--color-icon-desktopFullscreen-hover)',
  iconDesktopFullscreenOndisabled: 'var(--color-icon-desktopFullscreen-ondisabled)',
  iconDesktopFullscreenSecondary: 'var(--color-icon-desktopFullscreen-secondary)',
  iconDesktopFullscreenSecondaryHover: 'var(--color-icon-desktopFullscreen-secondary-hover)',
  iconDesktopFullscreenTertiary: 'var(--color-icon-desktopFullscreen-tertiary)',
  iconDesktopFullscreenTertiaryHover: 'var(--color-icon-desktopFullscreen-tertiary-hover)',
  iconDesktopFullscreenWarning: 'var(--color-icon-desktopFullscreen-warning)',
  iconDisabled: 'var(--color-icon-disabled)',
  iconFigjam: 'var(--color-icon-figjam)',
  iconFigjamPressed: 'var(--color-icon-figjam-pressed)',
  iconFigjamSecondary: 'var(--color-icon-figjam-secondary)',
  iconFigjamTertiary: 'var(--color-icon-figjam-tertiary)',
  iconFs: 'var(--color-icon-fs)',
  iconFsAssistive: 'var(--color-icon-fs-assistive)',
  iconFsComponent: 'var(--color-icon-fs-component)',
  iconFsDesign: 'var(--color-icon-fs-design)',
  iconFsMeasure: 'var(--color-icon-fs-measure)',
  iconFsOnassistive: 'var(--color-icon-fs-onassistive)',
  iconFsOncomponent: 'var(--color-icon-fs-oncomponent)',
  iconFsOndesign: 'var(--color-icon-fs-ondesign)',
  iconFsOnmeasure: 'var(--color-icon-fs-onmeasure)',
  iconFsOnselected: 'var(--color-icon-fs-onselected)',
  iconFsOntemplate: 'var(--color-icon-fs-ontemplate)',
  iconFsSecondary: 'var(--color-icon-fs-secondary)',
  iconFsSelected: 'var(--color-icon-fs-selected)',
  iconFsTemplate: 'var(--color-icon-fs-template)',
  iconFsTertiary: 'var(--color-icon-fs-tertiary)',
  iconHandoff: 'var(--color-icon-handoff)',
  iconHandoffPressed: 'var(--color-icon-handoff-pressed)',
  iconHandoffSecondary: 'var(--color-icon-handoff-secondary)',
  iconHandoffTertiary: 'var(--color-icon-handoff-tertiary)',
  iconHover: 'var(--color-icon-hover)',
  iconMeasure: 'var(--color-icon-measure)',
  iconMeasureHover: 'var(--color-icon-measure-hover)',
  iconMeasurePressed: 'var(--color-icon-measure-pressed)',
  iconMeasureSecondary: 'var(--color-icon-measure-secondary)',
  iconMeasureSecondaryHover: 'var(--color-icon-measure-secondary-hover)',
  iconMeasureTertiary: 'var(--color-icon-measure-tertiary)',
  iconMenu: 'var(--color-icon-menu)',
  iconMenuDanger: 'var(--color-icon-menu-danger)',
  iconMenuDisabled: 'var(--color-icon-menu-disabled)',
  iconMenuHover: 'var(--color-icon-menu-hover)',
  iconMenuOndisabled: 'var(--color-icon-menu-ondisabled)',
  iconMenuOnselected: 'var(--color-icon-menu-onselected)',
  iconMenuPressed: 'var(--color-icon-menu-pressed)',
  iconMenuSecondary: 'var(--color-icon-menu-secondary)',
  iconMenuSecondaryHover: 'var(--color-icon-menu-secondary-hover)',
  iconMenuSelected: 'var(--color-icon-menu-selected)',
  iconMenuSelectedSecondary: 'var(--color-icon-menu-selected-secondary)',
  iconMenuSelectedTertiary: 'var(--color-icon-menu-selected-tertiary)',
  iconMenuTertiary: 'var(--color-icon-menu-tertiary)',
  iconMenuTertiaryHover: 'var(--color-icon-menu-tertiary-hover)',
  iconMenuWarning: 'var(--color-icon-menu-warning)',
  iconOnassistive: 'var(--color-icon-onassistive)',
  iconOnassistiveSecondary: 'var(--color-icon-onassistive-secondary)',
  iconOnassistiveTertiary: 'var(--color-icon-onassistive-tertiary)',
  iconOnbrand: 'var(--color-icon-onbrand)',
  iconOnbrandSecondary: 'var(--color-icon-onbrand-secondary)',
  iconOnbrandTertiary: 'var(--color-icon-onbrand-tertiary)',
  iconOncomponent: 'var(--color-icon-oncomponent)',
  iconOncomponentSecondary: 'var(--color-icon-oncomponent-secondary)',
  iconOncomponentTertiary: 'var(--color-icon-oncomponent-tertiary)',
  iconOndanger: 'var(--color-icon-ondanger)',
  iconOndangerSecondary: 'var(--color-icon-ondanger-secondary)',
  iconOndangerTertiary: 'var(--color-icon-ondanger-tertiary)',
  iconOndesign: 'var(--color-icon-ondesign)',
  iconOndesignSecondary: 'var(--color-icon-ondesign-secondary)',
  iconOndesignTertiary: 'var(--color-icon-ondesign-tertiary)',
  iconOndisabled: 'var(--color-icon-ondisabled)',
  iconOnfigjam: 'var(--color-icon-onfigjam)',
  iconOnfigjamSecondary: 'var(--color-icon-onfigjam-secondary)',
  iconOnfigjamTertiary: 'var(--color-icon-onfigjam-tertiary)',
  iconOninverse: 'var(--color-icon-oninverse)',
  iconOnmeasure: 'var(--color-icon-onmeasure)',
  iconOnmeasureSecondary: 'var(--color-icon-onmeasure-secondary)',
  iconOnmeasureTertiary: 'var(--color-icon-onmeasure-tertiary)',
  iconOnselected: 'var(--color-icon-onselected)',
  iconOnselectedSecondary: 'var(--color-icon-onselected-secondary)',
  iconOnselectedStrong: 'var(--color-icon-onselected-strong)',
  iconOnselectedTertiary: 'var(--color-icon-onselected-tertiary)',
  iconOnsuccess: 'var(--color-icon-onsuccess)',
  iconOnsuccessSecondary: 'var(--color-icon-onsuccess-secondary)',
  iconOnsuccessTertiary: 'var(--color-icon-onsuccess-tertiary)',
  iconOntemplate: 'var(--color-icon-ontemplate)',
  iconOnwarning: 'var(--color-icon-onwarning)',
  iconOnwarningSecondary: 'var(--color-icon-onwarning-secondary)',
  iconOnwarningTertiary: 'var(--color-icon-onwarning-tertiary)',
  iconPressed: 'var(--color-icon-pressed)',
  iconSecondary: 'var(--color-icon-secondary)',
  iconSecondaryHover: 'var(--color-icon-secondary-hover)',
  iconSelected: 'var(--color-icon-selected)',
  iconSelectedSecondary: 'var(--color-icon-selected-secondary)',
  iconSelectedTertiary: 'var(--color-icon-selected-tertiary)',
  iconSuccess: 'var(--color-icon-success)',
  iconSuccessPressed: 'var(--color-icon-success-pressed)',
  iconSuccessSecondary: 'var(--color-icon-success-secondary)',
  iconSuccessTertiary: 'var(--color-icon-success-tertiary)',
  iconTemplate: 'var(--color-icon-template)',
  iconTemplateSecondary: 'var(--color-icon-template-secondary)',
  iconTertiary: 'var(--color-icon-tertiary)',
  iconTertiaryHover: 'var(--color-icon-tertiary-hover)',
  iconToolbar: 'var(--color-icon-toolbar)',
  iconToolbarDanger: 'var(--color-icon-toolbar-danger)',
  iconToolbarDisabled: 'var(--color-icon-toolbar-disabled)',
  iconToolbarHover: 'var(--color-icon-toolbar-hover)',
  iconToolbarOndisabled: 'var(--color-icon-toolbar-ondisabled)',
  iconToolbarOnselected: 'var(--color-icon-toolbar-onselected)',
  iconToolbarPressed: 'var(--color-icon-toolbar-pressed)',
  iconToolbarSecondary: 'var(--color-icon-toolbar-secondary)',
  iconToolbarSecondaryHover: 'var(--color-icon-toolbar-secondary-hover)',
  iconToolbarSelected: 'var(--color-icon-toolbar-selected)',
  iconToolbarSelectedSecondary: 'var(--color-icon-toolbar-selected-secondary)',
  iconToolbarSelectedTertiary: 'var(--color-icon-toolbar-selected-tertiary)',
  iconToolbarTertiary: 'var(--color-icon-toolbar-tertiary)',
  iconToolbarTertiaryHover: 'var(--color-icon-toolbar-tertiary-hover)',
  iconToolbarWarning: 'var(--color-icon-toolbar-warning)',
  iconTooltip: 'var(--color-icon-tooltip)',
  iconTooltipDanger: 'var(--color-icon-tooltip-danger)',
  iconTooltipDisabled: 'var(--color-icon-tooltip-disabled)',
  iconTooltipHover: 'var(--color-icon-tooltip-hover)',
  iconTooltipOndisabled: 'var(--color-icon-tooltip-ondisabled)',
  iconTooltipOnselected: 'var(--color-icon-tooltip-onselected)',
  iconTooltipPressed: 'var(--color-icon-tooltip-pressed)',
  iconTooltipSecondary: 'var(--color-icon-tooltip-secondary)',
  iconTooltipSecondaryHover: 'var(--color-icon-tooltip-secondary-hover)',
  iconTooltipSelected: 'var(--color-icon-tooltip-selected)',
  iconTooltipSelectedSecondary: 'var(--color-icon-tooltip-selected-secondary)',
  iconTooltipSelectedTertiary: 'var(--color-icon-tooltip-selected-tertiary)',
  iconTooltipTertiary: 'var(--color-icon-tooltip-tertiary)',
  iconTooltipTertiaryHover: 'var(--color-icon-tooltip-tertiary-hover)',
  iconTooltipWarning: 'var(--color-icon-tooltip-warning)',
  iconWarning: 'var(--color-icon-warning)',
  iconWarningPressed: 'var(--color-icon-warning-pressed)',
  iconWarningSecondary: 'var(--color-icon-warning-secondary)',
  iconWarningTertiary: 'var(--color-icon-warning-tertiary)',
  icondesignfilesecondary: 'var(--color-icondesignfilesecondary)',
  iconfavorite: 'var(--color-iconfavorite)',
  iconfigjamfilesecondary: 'var(--color-iconfigjamfilesecondary)',
  iconondarkcanvas: 'var(--color-iconondarkcanvas)',
  icononlightcanvas: 'var(--color-icononlightcanvas)',
  icononvoting: 'var(--color-icononvoting)',
  iconprototypefile: 'var(--color-iconprototypefile)',
  iconprototypefilesecondary: 'var(--color-iconprototypefilesecondary)',
  iconpublishedfile: 'var(--color-iconpublishedfile)',
  iconpublishedfilesecondary: 'var(--color-iconpublishedfilesecondary)',
  loading: 'var(--color-loading)',
  loadingmenu: 'var(--color-loadingmenu)',
  loadingsecondary: 'var(--color-loadingsecondary)',
  loadingsecondarymenu: 'var(--color-loadingsecondarymenu)',
  modalbackdrop: 'var(--color-modalbackdrop)',
  multiplayerblue: 'var(--color-multiplayerblue)',
  multiplayerbluehover: 'var(--color-multiplayerbluehover)',
  multiplayerbluesecondary: 'var(--color-multiplayerbluesecondary)',
  multiplayergreen: 'var(--color-multiplayergreen)',
  multiplayergreenhover: 'var(--color-multiplayergreenhover)',
  multiplayergreensecondary: 'var(--color-multiplayergreensecondary)',
  multiplayergrey: 'var(--color-multiplayergrey)',
  multiplayergreyhover: 'var(--color-multiplayergreyhover)',
  multiplayergreysecondary: 'var(--color-multiplayergreysecondary)',
  multiplayerpink: 'var(--color-multiplayerpink)',
  multiplayerpinkhover: 'var(--color-multiplayerpinkhover)',
  multiplayerpinksecondary: 'var(--color-multiplayerpinksecondary)',
  multiplayerpurple: 'var(--color-multiplayerpurple)',
  multiplayerpurplehover: 'var(--color-multiplayerpurplehover)',
  multiplayerpurplesecondary: 'var(--color-multiplayerpurplesecondary)',
  multiplayerred: 'var(--color-multiplayerred)',
  multiplayerredhover: 'var(--color-multiplayerredhover)',
  multiplayerredsecondary: 'var(--color-multiplayerredsecondary)',
  multiplayeryellow: 'var(--color-multiplayeryellow)',
  multiplayeryellowhover: 'var(--color-multiplayeryellowhover)',
  multiplayeryellowsecondary: 'var(--color-multiplayeryellowsecondary)',
  nodehandle: 'var(--color-nodehandle)',
  prototypeloadingbackdrop: 'var(--color-prototypeloadingbackdrop)',
  scrollbar: 'var(--color-scrollbar)',
  shadow: 'var(--color-shadow)',
  tablenodehoveredprimary: 'var(--color-tablenodehoveredprimary)',
  tablenodehoveredsecondary: 'var(--color-tablenodehoveredsecondary)',
  tablenodeselected: 'var(--color-tablenodeselected)',
  templateSlot: 'var(--color-template-slot)',
  text: 'var(--color-text)',
  textAssistive: 'var(--color-text-assistive)',
  textAssistivePressed: 'var(--color-text-assistive-pressed)',
  textAssistiveSecondary: 'var(--color-text-assistive-secondary)',
  textAssistiveTertiary: 'var(--color-text-assistive-tertiary)',
  textBrand: 'var(--color-text-brand)',
  textBrandSecondary: 'var(--color-text-brand-secondary)',
  textBrandTertiary: 'var(--color-text-brand-tertiary)',
  textComponent: 'var(--color-text-component)',
  textComponentPressed: 'var(--color-text-component-pressed)',
  textComponentSecondary: 'var(--color-text-component-secondary)',
  textComponentTertiary: 'var(--color-text-component-tertiary)',
  textDanger: 'var(--color-text-danger)',
  textDangerSecondary: 'var(--color-text-danger-secondary)',
  textDangerTertiary: 'var(--color-text-danger-tertiary)',
  textDesign: 'var(--color-text-design)',
  textDesignPressed: 'var(--color-text-design-pressed)',
  textDesignSecondary: 'var(--color-text-design-secondary)',
  textDesignTertiary: 'var(--color-text-design-tertiary)',
  textDesktopBackgrounded: 'var(--color-text-desktopBackgrounded)',
  textDesktopBackgroundedDanger: 'var(--color-text-desktopBackgrounded-danger)',
  textDesktopBackgroundedDisabled: 'var(--color-text-desktopBackgrounded-disabled)',
  textDesktopBackgroundedHover: 'var(--color-text-desktopBackgrounded-hover)',
  textDesktopBackgroundedOndisabled: 'var(--color-text-desktopBackgrounded-ondisabled)',
  textDesktopBackgroundedSecondary: 'var(--color-text-desktopBackgrounded-secondary)',
  textDesktopBackgroundedSecondaryHover: 'var(--color-text-desktopBackgrounded-secondary-hover)',
  textDesktopBackgroundedTertiary: 'var(--color-text-desktopBackgrounded-tertiary)',
  textDesktopBackgroundedTertiaryHover: 'var(--color-text-desktopBackgrounded-tertiary-hover)',
  textDesktopBackgroundedWarning: 'var(--color-text-desktopBackgrounded-warning)',
  textDesktopForeground: 'var(--color-text-desktopForeground)',
  textDesktopForegroundDanger: 'var(--color-text-desktopForeground-danger)',
  textDesktopForegroundDisabled: 'var(--color-text-desktopForeground-disabled)',
  textDesktopForegroundHover: 'var(--color-text-desktopForeground-hover)',
  textDesktopForegroundOndisabled: 'var(--color-text-desktopForeground-ondisabled)',
  textDesktopForegroundSecondary: 'var(--color-text-desktopForeground-secondary)',
  textDesktopForegroundSecondaryHover: 'var(--color-text-desktopForeground-secondary-hover)',
  textDesktopForegroundTertiary: 'var(--color-text-desktopForeground-tertiary)',
  textDesktopForegroundTertiaryHover: 'var(--color-text-desktopForeground-tertiary-hover)',
  textDesktopForegroundWarning: 'var(--color-text-desktopForeground-warning)',
  textDesktopFullscreen: 'var(--color-text-desktopFullscreen)',
  textDesktopFullscreenDanger: 'var(--color-text-desktopFullscreen-danger)',
  textDesktopFullscreenDisabled: 'var(--color-text-desktopFullscreen-disabled)',
  textDesktopFullscreenHover: 'var(--color-text-desktopFullscreen-hover)',
  textDesktopFullscreenOndisabled: 'var(--color-text-desktopFullscreen-ondisabled)',
  textDesktopFullscreenSecondary: 'var(--color-text-desktopFullscreen-secondary)',
  textDesktopFullscreenSecondaryHover: 'var(--color-text-desktopFullscreen-secondary-hover)',
  textDesktopFullscreenTertiary: 'var(--color-text-desktopFullscreen-tertiary)',
  textDesktopFullscreenTertiaryHover: 'var(--color-text-desktopFullscreen-tertiary-hover)',
  textDesktopFullscreenWarning: 'var(--color-text-desktopFullscreen-warning)',
  textDisabled: 'var(--color-text-disabled)',
  textFigjam: 'var(--color-text-figjam)',
  textFigjamPressed: 'var(--color-text-figjam-pressed)',
  textFigjamSecondary: 'var(--color-text-figjam-secondary)',
  textFigjamTertiary: 'var(--color-text-figjam-tertiary)',
  textFs: 'var(--color-text-fs)',
  textFsAssistive: 'var(--color-text-fs-assistive)',
  textFsComponent: 'var(--color-text-fs-component)',
  textFsDesign: 'var(--color-text-fs-design)',
  textFsMeasure: 'var(--color-text-fs-measure)',
  textFsOnassistive: 'var(--color-text-fs-onassistive)',
  textFsOncomponent: 'var(--color-text-fs-oncomponent)',
  textFsOndesign: 'var(--color-text-fs-ondesign)',
  textFsOnmeasure: 'var(--color-text-fs-onmeasure)',
  textFsOnselected: 'var(--color-text-fs-onselected)',
  textFsOntemplate: 'var(--color-text-fs-ontemplate)',
  textFsSecondary: 'var(--color-text-fs-secondary)',
  textFsSelected: 'var(--color-text-fs-selected)',
  textFsTemplate: 'var(--color-text-fs-template)',
  textFsTertiary: 'var(--color-text-fs-tertiary)',
  textHandoff: 'var(--color-text-handoff)',
  textHandoffSecondary: 'var(--color-text-handoff-secondary)',
  textHandoffTertiary: 'var(--color-text-handoff-tertiary)',
  textHover: 'var(--color-text-hover)',
  textLink: 'var(--color-text-link)',
  textMeasure: 'var(--color-text-measure)',
  textMeasureSecondary: 'var(--color-text-measure-secondary)',
  textMeasureTertiary: 'var(--color-text-measure-tertiary)',
  textMenu: 'var(--color-text-menu)',
  textMenuDanger: 'var(--color-text-menu-danger)',
  textMenuDisabled: 'var(--color-text-menu-disabled)',
  textMenuHover: 'var(--color-text-menu-hover)',
  textMenuOndisabled: 'var(--color-text-menu-ondisabled)',
  textMenuOnselected: 'var(--color-text-menu-onselected)',
  textMenuSecondary: 'var(--color-text-menu-secondary)',
  textMenuSecondaryHover: 'var(--color-text-menu-secondary-hover)',
  textMenuSelected: 'var(--color-text-menu-selected)',
  textMenuSelectedSecondary: 'var(--color-text-menu-selected-secondary)',
  textMenuSelectedTertiary: 'var(--color-text-menu-selected-tertiary)',
  textMenuTertiary: 'var(--color-text-menu-tertiary)',
  textMenuTertiaryHover: 'var(--color-text-menu-tertiary-hover)',
  textMenuWarning: 'var(--color-text-menu-warning)',
  textOnassistive: 'var(--color-text-onassistive)',
  textOnassistiveSecondary: 'var(--color-text-onassistive-secondary)',
  textOnassistiveTertiary: 'var(--color-text-onassistive-tertiary)',
  textOnbrand: 'var(--color-text-onbrand)',
  textOnbrandSecondary: 'var(--color-text-onbrand-secondary)',
  textOnbrandTertiary: 'var(--color-text-onbrand-tertiary)',
  textOncomponent: 'var(--color-text-oncomponent)',
  textOncomponentSecondary: 'var(--color-text-oncomponent-secondary)',
  textOncomponentTertiary: 'var(--color-text-oncomponent-tertiary)',
  textOndanger: 'var(--color-text-ondanger)',
  textOndangerSecondary: 'var(--color-text-ondanger-secondary)',
  textOndangerTertiary: 'var(--color-text-ondanger-tertiary)',
  textOndesign: 'var(--color-text-ondesign)',
  textOndesignSecondary: 'var(--color-text-ondesign-secondary)',
  textOndesignTertiary: 'var(--color-text-ondesign-tertiary)',
  textOndisabled: 'var(--color-text-ondisabled)',
  textOnfigjam: 'var(--color-text-onfigjam)',
  textOnfigjamSecondary: 'var(--color-text-onfigjam-secondary)',
  textOnfigjamTertiary: 'var(--color-text-onfigjam-tertiary)',
  textOninverse: 'var(--color-text-oninverse)',
  textOninverseSecondary: 'var(--color-text-oninverse-secondary)',
  textOnmeasure: 'var(--color-text-onmeasure)',
  textOnmeasureSecondary: 'var(--color-text-onmeasure-secondary)',
  textOnmeasureTertiary: 'var(--color-text-onmeasure-tertiary)',
  textOnselected: 'var(--color-text-onselected)',
  textOnselectedSecondary: 'var(--color-text-onselected-secondary)',
  textOnselectedStrong: 'var(--color-text-onselected-strong)',
  textOnselectedTertiary: 'var(--color-text-onselected-tertiary)',
  textOnsuccess: 'var(--color-text-onsuccess)',
  textOnsuccessSecondary: 'var(--color-text-onsuccess-secondary)',
  textOnsuccessTertiary: 'var(--color-text-onsuccess-tertiary)',
  textOntemplate: 'var(--color-text-ontemplate)',
  textOnwarning: 'var(--color-text-onwarning)',
  textOnwarningSecondary: 'var(--color-text-onwarning-secondary)',
  textOnwarningTertiary: 'var(--color-text-onwarning-tertiary)',
  textSecondary: 'var(--color-text-secondary)',
  textSecondaryHover: 'var(--color-text-secondary-hover)',
  textSelected: 'var(--color-text-selected)',
  textSelectedSecondary: 'var(--color-text-selected-secondary)',
  textSelectedTertiary: 'var(--color-text-selected-tertiary)',
  textSuccess: 'var(--color-text-success)',
  textSuccessSecondary: 'var(--color-text-success-secondary)',
  textSuccessTertiary: 'var(--color-text-success-tertiary)',
  textTemplate: 'var(--color-text-template)',
  textTemplateSecondary: 'var(--color-text-template-secondary)',
  textTertiary: 'var(--color-text-tertiary)',
  textTertiaryHover: 'var(--color-text-tertiary-hover)',
  textToolbar: 'var(--color-text-toolbar)',
  textToolbarDanger: 'var(--color-text-toolbar-danger)',
  textToolbarDisabled: 'var(--color-text-toolbar-disabled)',
  textToolbarHover: 'var(--color-text-toolbar-hover)',
  textToolbarOndisabled: 'var(--color-text-toolbar-ondisabled)',
  textToolbarOnselected: 'var(--color-text-toolbar-onselected)',
  textToolbarSecondary: 'var(--color-text-toolbar-secondary)',
  textToolbarSecondaryHover: 'var(--color-text-toolbar-secondary-hover)',
  textToolbarSelected: 'var(--color-text-toolbar-selected)',
  textToolbarSelectedSecondary: 'var(--color-text-toolbar-selected-secondary)',
  textToolbarSelectedTertiary: 'var(--color-text-toolbar-selected-tertiary)',
  textToolbarTertiary: 'var(--color-text-toolbar-tertiary)',
  textToolbarTertiaryHover: 'var(--color-text-toolbar-tertiary-hover)',
  textToolbarWarning: 'var(--color-text-toolbar-warning)',
  textTooltip: 'var(--color-text-tooltip)',
  textTooltipDanger: 'var(--color-text-tooltip-danger)',
  textTooltipDisabled: 'var(--color-text-tooltip-disabled)',
  textTooltipHover: 'var(--color-text-tooltip-hover)',
  textTooltipOndisabled: 'var(--color-text-tooltip-ondisabled)',
  textTooltipOnselected: 'var(--color-text-tooltip-onselected)',
  textTooltipSecondary: 'var(--color-text-tooltip-secondary)',
  textTooltipSecondaryHover: 'var(--color-text-tooltip-secondary-hover)',
  textTooltipSelected: 'var(--color-text-tooltip-selected)',
  textTooltipSelectedSecondary: 'var(--color-text-tooltip-selected-secondary)',
  textTooltipSelectedTertiary: 'var(--color-text-tooltip-selected-tertiary)',
  textTooltipTertiary: 'var(--color-text-tooltip-tertiary)',
  textTooltipTertiaryHover: 'var(--color-text-tooltip-tertiary-hover)',
  textTooltipWarning: 'var(--color-text-tooltip-warning)',
  textWarning: 'var(--color-text-warning)',
  textWarningSecondary: 'var(--color-text-warning-secondary)',
  textWarningTertiary: 'var(--color-text-warning-tertiary)',
  texthighlight: 'var(--color-texthighlight)',
  textondarkannotation: 'var(--color-textondarkannotation)',
  textondarkcanvas: 'var(--color-textondarkcanvas)',
  textondarkcanvassecondary: 'var(--color-textondarkcanvassecondary)',
  textoninspectpadding: 'var(--color-textoninspectpadding)',
  textoninspectspacing: 'var(--color-textoninspectspacing)',
  textonlightannotation: 'var(--color-textonlightannotation)',
  textonlightcanvas: 'var(--color-textonlightcanvas)',
  textonlightcanvassecondary: 'var(--color-textonlightcanvassecondary)',
  textonmultiplayerblue: 'var(--color-textonmultiplayerblue)',
  textonmultiplayergreen: 'var(--color-textonmultiplayergreen)',
  textonmultiplayergrey: 'var(--color-textonmultiplayergrey)',
  textonmultiplayerpink: 'var(--color-textonmultiplayerpink)',
  textonmultiplayerpurple: 'var(--color-textonmultiplayerpurple)',
  textonmultiplayerred: 'var(--color-textonmultiplayerred)',
  textonmultiplayeryellow: 'var(--color-textonmultiplayeryellow)',
  textonvoting: 'var(--color-textonvoting)',
  timelinenodedefault: 'var(--color-timelinenodedefault)',
  timelinenodedefaulthover: 'var(--color-timelinenodedefaulthover)'
})
export const font = stylex.defineConsts({
  fontFamilyDefault: 'var(--font-family-default)',
  fontFamilyDisplay: 'var(--font-family-display)',
  fontFamilyMono: 'var(--font-family-mono)'
})
export const shadow = stylex.defineConsts({
  elevation100: 'var(--elevation-100)',
  elevation200: 'var(--elevation-200)',
  elevation300: 'var(--elevation-300)',
  elevation400: 'var(--elevation-400)',
  elevation500: 'var(--elevation-500)',
  elevation100DropShadow: 'var(--elevation-100-drop-shadow)',
  elevation200DropShadow: 'var(--elevation-200-drop-shadow)',
  elevation300DropShadow: 'var(--elevation-300-drop-shadow)',
  elevation400DropShadow: 'var(--elevation-400-drop-shadow)',
  elevation500DropShadow: 'var(--elevation-500-drop-shadow)'
})
export const spacer = stylex.defineConsts({
  spacer0: 'var(--spacer-0)',
  spacer0px: 'var(--spacer-0px)',
  spacer1: 'var(--spacer-1)',
  spacer2: 'var(--spacer-2)',
  spacer25: 'var(--spacer-2-5)',
  spacer3: 'var(--spacer-3)',
  spacer4: 'var(--spacer-4)',
  spacer4px: 'var(--spacer-4px)',
  spacer5: 'var(--spacer-5)',
  spacer6: 'var(--spacer-6)',
  spacer8px: 'var(--spacer-8px)',
  spacer12px: 'var(--spacer-12px)',
  spacer16px: 'var(--spacer-16px)',
  spacer24px: 'var(--spacer-24px)',
  spacer32px: 'var(--spacer-32px)',
  spacer40px: 'var(--spacer-40px)'
})
export const fontWeight = stylex.defineConsts({
  fontWeightDefault: 'var(--font-weight-default)',
  fontWeightStrong: 'var(--font-weight-strong)'
})
export const borderRadius = stylex.defineConsts({
  full: 'var(--radius-full)',
  large: 'var(--radius-large)',
  medium: 'var(--radius-medium)',
  none: 'var(--radius-none)',
  small: 'var(--radius-small)'
})
export const typography = stylex.defineConsts({
  textBodyLargeFontFamily: 'var(--text-body-large-font-family)',
  textBodyLargeFontSize: 'var(--text-body-large-font-size)',
  textBodyLargeFontWeight: 'var(--text-body-large-font-weight)',
  textBodyLargeLineHeight: 'var(--text-body-large-line-height)',
  textBodyLargeLetterSpacing: 'var(--text-body-large-letter-spacing)',
  textBodyLargeStrongFontFamily: 'var(--text-body-large-strong-font-family)',
  textBodyLargeStrongFontSize: 'var(--text-body-large-strong-font-size)',
  textBodyLargeStrongFontWeight: 'var(--text-body-large-strong-font-weight)',
  textBodyLargeStrongLineHeight: 'var(--text-body-large-strong-line-height)',
  textBodyLargeStrongLetterSpacing: 'var(--text-body-large-strong-letter-spacing)',
  textBodyMediumFontFamily: 'var(--text-body-medium-font-family)',
  textBodyMediumFontSize: 'var(--text-body-medium-font-size)',
  textBodyMediumFontWeight: 'var(--text-body-medium-font-weight)',
  textBodyMediumLineHeight: 'var(--text-body-medium-line-height)',
  textBodyMediumLetterSpacing: 'var(--text-body-medium-letter-spacing)',
  textBodyMediumStrongFontFamily: 'var(--text-body-medium-strong-font-family)',
  textBodyMediumStrongFontSize: 'var(--text-body-medium-strong-font-size)',
  textBodyMediumStrongFontWeight: 'var(--text-body-medium-strong-font-weight)',
  textBodyMediumStrongLineHeight: 'var(--text-body-medium-strong-line-height)',
  textBodyMediumStrongLetterSpacing: 'var(--text-body-medium-strong-letter-spacing)',
  textBodySmallFontFamily: 'var(--text-body-small-font-family)',
  textBodySmallFontSize: 'var(--text-body-small-font-size)',
  textBodySmallFontWeight: 'var(--text-body-small-font-weight)',
  textBodySmallLineHeight: 'var(--text-body-small-line-height)',
  textBodySmallLetterSpacing: 'var(--text-body-small-letter-spacing)',
  textBodySmallStrongFontFamily: 'var(--text-body-small-strong-font-family)',
  textBodySmallStrongFontSize: 'var(--text-body-small-strong-font-size)',
  textBodySmallStrongFontWeight: 'var(--text-body-small-strong-font-weight)',
  textBodySmallStrongLineHeight: 'var(--text-body-small-strong-line-height)',
  textBodySmallStrongLetterSpacing: 'var(--text-body-small-strong-letter-spacing)',
  textDisplayFontFamily: 'var(--text-display-font-family)',
  textDisplayFontSize: 'var(--text-display-font-size)',
  textDisplayFontWeight: 'var(--text-display-font-weight)',
  textDisplayLineHeight: 'var(--text-display-line-height)',
  textDisplayLetterSpacing: 'var(--text-display-letter-spacing)',
  textHeadingLargeFontFamily: 'var(--text-heading-large-font-family)',
  textHeadingLargeFontSize: 'var(--text-heading-large-font-size)',
  textHeadingLargeFontWeight: 'var(--text-heading-large-font-weight)',
  textHeadingLargeLineHeight: 'var(--text-heading-large-line-height)',
  textHeadingLargeLetterSpacing: 'var(--text-heading-large-letter-spacing)',
  textHeadingMediumFontFamily: 'var(--text-heading-medium-font-family)',
  textHeadingMediumFontSize: 'var(--text-heading-medium-font-size)',
  textHeadingMediumFontWeight: 'var(--text-heading-medium-font-weight)',
  textHeadingMediumLineHeight: 'var(--text-heading-medium-line-height)',
  textHeadingMediumLetterSpacing: 'var(--text-heading-medium-letter-spacing)',
  textHeadingSmallFontFamily: 'var(--text-heading-small-font-family)',
  textHeadingSmallFontSize: 'var(--text-heading-small-font-size)',
  textHeadingSmallFontWeight: 'var(--text-heading-small-font-weight)',
  textHeadingSmallLineHeight: 'var(--text-heading-small-line-height)',
  textHeadingSmallLetterSpacing: 'var(--text-heading-small-letter-spacing)',
  textMonoLargeFontFamily: 'var(--text-mono-large-font-family)',
  textMonoLargeFontSize: 'var(--text-mono-large-font-size)',
  textMonoLargeFontWeight: 'var(--text-mono-large-font-weight)',
  textMonoLargeLineHeight: 'var(--text-mono-large-line-height)',
  textMonoLargeLetterSpacing: 'var(--text-mono-large-letter-spacing)',
  textMonoMediumFontFamily: 'var(--text-mono-medium-font-family)',
  textMonoMediumFontSize: 'var(--text-mono-medium-font-size)',
  textMonoMediumFontWeight: 'var(--text-mono-medium-font-weight)',
  textMonoMediumLineHeight: 'var(--text-mono-medium-line-height)',
  textMonoMediumLetterSpacing: 'var(--text-mono-medium-letter-spacing)',
  textMonoSmallFontFamily: 'var(--text-mono-small-font-family)',
  textMonoSmallFontSize: 'var(--text-mono-small-font-size)',
  textMonoSmallFontWeight: 'var(--text-mono-small-font-weight)',
  textMonoSmallLineHeight: 'var(--text-mono-small-line-height)',
  textMonoSmallLetterSpacing: 'var(--text-mono-small-letter-spacing)'
})
export const duration = stylex.defineConsts({
  lg: 'var(--duration-lg)',
  md: 'var(--duration-md)',
  none: 'var(--duration-none)',
  sm: 'var(--duration-sm)'
})
export const zIndex = stylex.defineConsts({
  assistant: 'var(--z-index-assistant)',
  canvasBase: 'var(--z-index-canvas-base)',
  canvasModifiers: 'var(--z-index-canvas-modifiers)',
  canvasPin: 'var(--z-index-canvas-pin)',
  canvasPinActive: 'var(--z-index-canvas-pin-active)',
  contextEditing: 'var(--z-index-context-editing)',
  cursorMultiplayer: 'var(--z-index-cursor-multiplayer)',
  cursorMultiplayerEmote: 'var(--z-index-cursor-multiplayer-emote)',
  cursorUser: 'var(--z-index-cursor-user)',
  cursorUserEmote: 'var(--z-index-cursor-user-emote)',
  dropdown: 'var(--z-index-dropdown)',
  modal: 'var(--z-index-modal)',
  nav: 'var(--z-index-nav)',
  scrubCursor: 'var(--z-index-scrub-cursor)',
  sidebar: 'var(--z-index-sidebar)',
  toolbarWidgets: 'var(--z-index-toolbar-widgets)',
  tooltip: 'var(--z-index-tooltip)',
  visualBell: 'var(--z-index-visual-bell)',
  window: 'var(--z-index-window)'
})
